import { EOnboaringFormStep } from '@constants';

import {
  ChooseCourses,
  ChosenReasons,
  CompleteProfile,
  DefineYourGoal,
  DiscoverSources,
  MasterTeacher,
  PrepareForChallenge,
  StudyPlan,
  SubjectNotes,
  YourSituation,
  DefineYourGoalFP,
  DefineYourGoalOpos,
  FinalStep,
  CompleteProfileFP
} from '../components/steps';

export const onboardingStepComponentMap: Record<EOnboaringFormStep, React.ReactNode> = {
  [EOnboaringFormStep.COMPLETE_PROFILE]: <CompleteProfile />,
  [EOnboaringFormStep.COMPLETE_PROFILE_FP]: <CompleteProfileFP />,
  [EOnboaringFormStep.YOU_HAVE_MASTER_DEGREE]: <MasterTeacher />,
  [EOnboaringFormStep.DEFINE_YOUR_GOAL]: <DefineYourGoal />,
  [EOnboaringFormStep.DEFINE_YOUR_GOAL_FP]: <DefineYourGoalFP />,
  [EOnboaringFormStep.DEFINE_YOUR_GOAL_OPOS]: <DefineYourGoalOpos />,
  [EOnboaringFormStep.YOUR_SITUATION]: <YourSituation />,
  [EOnboaringFormStep.PREPAIR_FOR_THE_CHALLENGE]: <PrepareForChallenge />,
  [EOnboaringFormStep.SUBJECT_NOTES]: <SubjectNotes />,
  [EOnboaringFormStep.STUDY_PLAN]: <StudyPlan />,
  [EOnboaringFormStep.CHOOSE_COURSES]: <ChooseCourses />,
  [EOnboaringFormStep.DISCOVER_SOURCES]: <DiscoverSources />,
  [EOnboaringFormStep.CHOSEN_REASONS]: <ChosenReasons />,
  [EOnboaringFormStep.FINAL_STEP]: <FinalStep />
};
